(function () {
  'use strict';

  // AJAX add-to-cart for homepage flavour cards.
  // Intercepts .icemix-ps__card-form submissions, POSTs to /cart/add.js with
  // sections payload, then calls cart-drawer.renderContents() to update and
  // open the drawer — same path product-form.js takes on PDPs.
  document.addEventListener('submit', async function (e) {
    if (!e.target.matches('.icemix-ps__card-form')) return;
    e.preventDefault();

    var form = e.target;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');

    try {
      var formData = new FormData(form);
      var cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer) {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: formData,
      });
      var data = await res.json();

      if (data.status) {
        window.location.href = '/cart';
        return;
      }

      if (!cartDrawer) {
        window.location.href = '/cart';
        return;
      }

      if (data.sections) {
        cartDrawer.renderContents(data);
        // Dawn's renderContents removes is-empty from .drawer__inner, but the
        // class actually lives on the <cart-drawer> wrapper (cart-drawer.liquid:22).
        // open() checks this.classList for is-empty to decide what to trapFocus on;
        // if stale, it looks for .drawer__inner-empty which is absent → null → crash.
        cartDrawer.classList.remove('is-empty');
      } else {
        await refreshDrawer();
      }
    } catch (_) {
      window.location.href = '/cart';
    } finally {
      if (btn) btn.removeAttribute('aria-disabled');
    }
  });

  async function refreshDrawer() {
    var res = await fetch('/?section_id=cart-drawer', { credentials: 'same-origin' });
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newCartDrawer = doc.querySelector('cart-drawer');
    var currentCartDrawer = document.querySelector('cart-drawer');
    if (newCartDrawer && currentCartDrawer) {
      currentCartDrawer.outerHTML = newCartDrawer.outerHTML;
      var freshDrawer = document.querySelector('cart-drawer');
      if (freshDrawer) freshDrawer.open();
    } else if (currentCartDrawer) {
      currentCartDrawer.open();
    }
  }
})();
